import PeopleIcon from '@material-ui/icons/People';
import GET_CLASSROOM_NAME from 'graph/classroom/get-classroom-name-query';
import { RouteConfig, RouteId, GetBreadcrumbsResponse } from 'types';
import ClassroomDetails from '../ClassroomDetails';

const routePrefix = '/classrooms';

const routes: RouteConfig[] = [
  {
    Component: ClassroomDetails,
    getTitle: () => 'Students',
    getBreadcrumbs: ({ match, client, ...appRoute }): GetBreadcrumbsResponse => {
      const classroomId = Number(match?.params?.classroomId);
      let result;

      try {
        const data = client.readQuery({
          query: GET_CLASSROOM_NAME,
          variables: { id: Number(classroomId) }
        });

        if (data?.classroom) {
          result = data.classroom;
        }
      } catch {
        // do nothing
      }

      return [
        {
          name: 'My Classes & Students',
          path: '/classrooms',
          Icon: PeopleIcon
        },
        {
          name: result?.name || 'Students',
          path: `${routePrefix}/${classroomId}`
        }
      ];
    },
    path: `${routePrefix}/:classroomId`,
    id: RouteId.CLASSROOMS_DETAILS,
    privileges: []
  }
];

const getRoutes = (): RouteConfig[] => {
  return routes;
};

export default getRoutes;
